import BaseApiService from "./BaseApiService";

const uiRecommend = (phoneNumber='+16462851319', id='da12275f2b214c4284834d994a262739') => {
    console.log(`/api/v1/shopping/${phoneNumber}/${id}`)
    return BaseApiService.get(
        `/api/v1/shopping/${phoneNumber}/${id}`,
        null,
        null
    );
};

const shoppingList = (phoneNumber, id) => {
    return BaseApiService.get(
        `/api/v1/shopping/list/${phoneNumber}/${id}`,
        null,
        null
    );
};

const quickView = (payload) => {
    // { "title":"Apple MacBook Air M2"}
    return BaseApiService.post(`/api/v1/product_quick_view`,null,payload);
};


export const UIRecommendationAPIService = {
    uiRecommend,
    shoppingList,
    quickView
};